import React from "react";
import Popover, { PopoverAnimationVertical } from "material-ui/Popover";

export default class CustomPopover extends React.PureComponent {
    render() {
        const { open, anchorEl, anchorOrigin, targetOrigin } = this.props;
        return (
            <Popover
                {...this.props}
                open={open ? open : false}
                anchorEl={anchorEl}
                anchorOrigin={anchorOrigin}
                targetOrigin={targetOrigin}
                animation={PopoverAnimationVertical}
            />
        );
    }
}
